import React from 'react';

import { ReactFCV } from '@types';

import { SHeader, SInput, SInputWithHeader, SText } from './styled';

export interface IInputWithHeader {
  postfixDataTestId: string;
  withText?: boolean;
}
export const InputWithHeader: ReactFCV<IInputWithHeader> = ({ postfixDataTestId, withText = false }) => (
  <SInputWithHeader data-testid={`styled-input-with-header-${postfixDataTestId}`}>
    <SHeader data-testid={`styled-header-${postfixDataTestId}`} />
    <SInput data-testid={`styled-input-${postfixDataTestId}`} />
    {withText && <SText data-testid={`styled-text-${postfixDataTestId}`} />}
  </SInputWithHeader>
);
